import { render, staticRenderFns } from "./HCP_details.vue?vue&type=template&id=54358da2&scoped=true"
import script from "./HCP_details.vue?vue&type=script&lang=js"
export * from "./HCP_details.vue?vue&type=script&lang=js"
import style0 from "./HCP_details.vue?vue&type=style&index=0&id=54358da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54358da2",
  null
  
)

export default component.exports